import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { Box } from '../Box/index.js';

var hiddenVisuallyCSS = {
    position: "absolute",
    overflow: "hidden",
    width: 1,
    height: 1,
    clip: "rect(1px, 1px, 1px, 1px)",
    whiteSpace: "nowrap",
};
var HiddenVisually = function (_a) {
    var sx = _a.sx, props = __rest(_a, ["sx"]);
    return jsx(Box, __assign({}, props, { sx: __assign(__assign({}, hiddenVisuallyCSS), sx) }));
};

export { HiddenVisually, hiddenVisuallyCSS };
//# sourceMappingURL=index.js.map
